import * as Yup from 'yup';
import { LabelSettingProps } from '../../../global/models/epi-model';
import { ClergyBioAddressValidationSchema } from '../../../global/validation-schemas/address-form-validation';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioPersonalInfoFormModel } from './model/form-models';

export function ConstructPayload(values: ClergyBioPersonalInfoFormModel) {
	return {
		personal: {
			religious_order: values?.religiousOrder,
			place_of_birth: values?.placeOfBirth,
			first_name_for_publication: values?.firstName,
			middle_name_for_publication: values?.middleName,
			last_name_at_birth: values.lastName,
			web_page_attributes: {
				url: values?.personalWebsite,
			},
		},
		published_address: {
			address1: values?.address1,
			address2: values?.address2,
			address3: values?.country === 'US' ? '' : values?.address3,
			city: values?.city,
			state: values?.state,
			postal_code: values?.postalCode,
			country: values?.country,
		},
		clergy_info_confirmed: values?.clergyInfoConfirmed,
	};
}

export function GetClergyBioPersonUpdateValidationSchema(labelSettings: LabelSettingProps, cleryBioSettings: ClergyBioSettings, isNewClergy?: boolean) {

	if (isNewClergy) {
		return Yup.object().shape({
			...ClergyBioAddressValidationSchema(labelSettings),
			clergyInfoConfirmed: Yup.bool().required(cleryBioSettings?.newClergyRequiredMessage).oneOf([true], cleryBioSettings.newClergyRequiredMessage),
		});

	}

	return Yup.object().shape({
		...ClergyBioAddressValidationSchema(labelSettings),
	});
}